import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { TabStripModule } from '@progress/kendo-angular-layout';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

import { NotificationContainerComponent} from './notification-container.component';
import { NotificationEditFeildComponent} from './notification-edit-feild.component';
import { NotificationLayoutComponent} from './notification-layout.component';
import { NotificationRailcarCPd} from './notification-railcar-cpd.component';
import { NotificationTraceResultsComponent} from './notification-trace-results.component';
import { CategoryNotificationComponent} from './category-notification.component';


@NgModule({
  declarations: [
    CategoryNotificationComponent,
    NotificationContainerComponent,
    NotificationEditFeildComponent,
    NotificationLayoutComponent,
    NotificationRailcarCPd,
    NotificationTraceResultsComponent,
  ],
  imports: [
    CommonModule, 
    FormsModule, 
    ReactiveFormsModule,
    DateInputsModule,
    ButtonsModule,
    TabStripModule,
    TooltipModule.forRoot(),
  ],
  exports: [ 
    CategoryNotificationComponent,
    NotificationContainerComponent,
    NotificationEditFeildComponent,
    NotificationLayoutComponent,
    NotificationRailcarCPd,
    NotificationTraceResultsComponent,
  ],
  providers: [],
})
export class NotificationModule { }